// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 913 ? "default" : chunkId) + "." + {"386":"4445190b","913":"ecd348e6"}[chunkId] + ".js";
};